module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-1af8f819.png";